export default "https://cdn-static.gokick.com/assets/e031f09406d9a12f4f19fb28fc50e3428375be91/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";